module.exports = __webpack_public_path__ + "img/ios.b4b1fa5a.svg";